<template>
    <div v-if="showActions" :class="gotBenchmark ? 'portfolio-actions' : 'portfolio-actions portfolio-actions--with-border'">
        <mds-button
            :id="portfolioTrigger"
            variation="flat"
            icon-right="angle-down"
            class="portfolio-name"
            @click="toggleMenu = !toggleMenu"
            e2e="portfolio-name"
        >
            <span :class="highlightClass">{{ getUILabel("portfolio_title") }} {{ getPortfolioNumber(portfolioIndex) }}</span> :
            {{ activePortfolio.name || "Untitled" }}
        </mds-button>
        <div v-if="gotBenchmark" class="benchmark-name">{{ benchmarkData.title }}: {{ benchmarkData.name }}</div>
        <mds-popover v-model="toggleMenu" title-hidden title="Default" :triggered-by="portfolioTrigger" :position="['bottom-center']" width="200px">
            <mds-list-group>
                <mds-list-group-item
                    v-for="option in menuOptions"
                    :key="option.trigger"
                    :text="option.label"
                    @mds-list-item-clicked="itemClicked(option.trigger)"
                ></mds-list-group-item>
            </mds-list-group>
        </mds-popover>
        <header-dialog
            :mwc-id="getMwcIdForChild('headerDialog')"
            :show="toggleDialog"
            :headerDialogConfig="dialogConfig"
            @dialog-close="dialogCloseHandler"
        ></header-dialog>
    </div>
</template>

<script>
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import HypoWorkflowMixin from "@/mixins/HypoWorkflowMixin";

import { MdsButton } from "@mds/button";
import MdsPopover from "@mds/popover";
import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";
import HeaderDialog from "./HeaderDialog";

export default {
    name: "portfolio-actions-header",
    mixins: [MwcSharedMixin, HypoWorkflowMixin],
    components: {
        MdsButton,
        MdsPopover,
        MdsListGroup,
        MdsListGroupItem,
        HeaderDialog
    },
    props: {
        portfolioIndex: {
            type: [Number, String]
        },
        benchmarkData: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            toggleMenu: false,
            toggleDialog: false,
            dialogConfig: {},
            menuOptions: [
                {
                    label: "Rename",
                    trigger: "rename"
                }
            ]
        };
    },
    beforeMount() {
        this.dialogConfig = this.defaultDialogConfig;
    },
    computed: {
        hypoType() {
            return parseInt(this.$store.getters["hypo/getType"]);
        },
        highlightClass() {
            return this.hypoType === 1 ? "highlight" : "";
        },
        showActions() {
            return this.hypoType === 0 || this.hypoType === 1;
        },
        portfolioTrigger() {
            return `portfolio-trigger-${this.portfolioIndex}`;
        },
        activePortfolio() {
            return this.$store.state.investments.portfolioList[this.portfolioIndex];
        },
        gotBenchmark() {
            if (!this.benchmarkData) {
                return false;
            }
            return Object.keys(this.benchmarkData).length > 0;
        }
    },
    methods: {
        dialogCloseHandler() {
            this.toggleDialog = false;
        },
        itemClicked() {
            this.dialogConfig = this.getDialogConfig("rename", "portfolio", this.portfolioIndex);
            this.toggleDialog = true;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@mds/constants";
@import "~@mds/typography";
.portfolio-actions {
    padding: $mds-space-1-and-a-half-x 0;
    & .portfolio-name {
        @include mds-level-5-heading();
        padding: 0;
    }
    & .benchmark-name {
        @include mds-body-text-m();
        margin-top: $mds-space-1-and-a-half-x;
    }
}
.highlight {
    font-weight: bold;
}
</style>
